import React, { Component, Fragment} from 'react';
import { SURVEYS_BY_LOC, SURVEYS_BY_MAP, SURVEYS_NO_LOC} from '../App';
import LoadingSpinner from './LoadingSpinner';
import EmptyState from './EmptyState';


class TasksNoLoc extends Component {

    
    render_surveys_no_loc = (loc) => {

        const { onOpen } = this.props;
        
        if (!loc.loc_scope)
            return (
                loc.loc_surveys.map((svy, index) => (
                    <div className='container-fluid border-top m-2' key={svy.survey}>
                        <div className="position-absolute end-0">
                            <button className="btn btn-secondary btn-sm m-2"
                                onClick={() => onOpen(index)} >Abrir</button>
                        </div>

                            <font size="2"><b>{svy.survey_title}</b></font>
                            <p style={{ "line-height": "0.8" }}> <font size="1"><i>
                                {svy.questions_per_survey} pregunta
                                {svy.questions_per_survey > 1 ? 's ' : ' '} por encuesta <br />
                                {svy.surveys_to_complete - svy.surveys_completed} encuesta
                                {(svy.surveys_to_complete - svy.surveys_completed) > 1 ? 's' : ''} por completar
                            </i></font></p>

                    </div>

                )
                ))
        else return null
    }
 


    render() {
        
        const { tasks_by_loc, isLoaded, onOpen, toogleClick } = this.props;


        if (isLoaded === false) {
            return <LoadingSpinner message="Cargando tareas…" />
        }
        if (!tasks_by_loc?.length) {
            return <EmptyState message="No hay datos disponibles." />
        }
        return (
                <Fragment>
                    <nav className="navbar-light bg-light py-2 border-bottom d-flex justify-content-between align-items-center px-2" >
                    <span className="navbar-brand mb-0 h6">Tareas</span>
                        <div className="btn-group" role="group" data-toggle="buttons">
                            <button type="button" className="btn btn-sm btn-outline-secondary "
                                onClick={() => toogleClick(SURVEYS_BY_LOC)}>List</button>
                            <button type="button" className="btn btn-sm btn-outline-secondary"
                                onClick={() => toogleClick(SURVEYS_BY_MAP)}>Map</button>
                            <button type="button" className="btn btn-sm btn-outline-secondary active"
                                onClick={() => toogleClick(SURVEYS_NO_LOC)}>No Loc</button>
                        </div>
                    </nav>
                    <h5>Encuestas Experieciales</h5>
                    {tasks_by_loc.map((loc) => (
                        this.render_surveys_no_loc(loc)
                    ))}
                </Fragment >
            )
    }
}
 
export default TasksNoLoc;